(function () {
    'use strict';

    angular
        .module('app')
        .directive('pageSearchBlock', pageSearchBlock);

    pageSearchBlock.$inject = ['$window', 'pageSearchService'];

    function pageSearchBlock($window, pageSearchService) {
        var directive = {
            bindToController: true,
            controller: ['$scope', '$location', controller],
            controllerAs: '$pageSearchBlock',
            restrict: 'EA',
            link: link
        };

        return directive;

        function link($scope) {
			$("#searchBox").autocomplete({
				highlight: true,
                source: function (request, response) {
                    $.ajax({
                        url: "/api/emr/search/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.searchAutocompSize
                        },
                        success: function (data) {
                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
				},
				select: function (event, ui) {
	                $(this).val(ui.item.value);
	                $(this).trigger('input'); // Use for Chrome/Firefox/Edge
	                $(this).trigger('change');
	                $(this).closest('form').submit();
                },
                minLength: 2
            });
        }

        function controller($scope, $location) {
            var $ctrl = this;

            $ctrl.text = "";
            $ctrl.prevTerm = "";
            $ctrl.sort = "relevance";
            $ctrl.relOrder = "desc";
            $ctrl.dateOrder = "desc";
            $ctrl.sites = [];
            $ctrl.publications = [];
			$ctrl.categoryFilters = [];
            $ctrl.selectedCategories = [];
            $ctrl.selectedSites = [];
            $ctrl.selectedPublications = [];
            $ctrl.contentTypes = [];
            $ctrl.selectedContentTypes = [];
            $ctrl.page = 1;
            $ctrl.pageSize = 10;
            $ctrl.externalPageSize = 10;
            $ctrl.maxPages = 5;
            $ctrl.pages = [];
            $ctrl.results = [];
            $ctrl.shownResults = [];
            $ctrl.externalResults = [];
            $ctrl.totalResults = 0;
            $ctrl.sitesHits = 0;
            $ctrl.contentTypeHits = 0;
			$ctrl.topicHits = 0;
            $ctrl.trainingHits = 0;
            $ctrl.publicationHits = 0;
            $ctrl.loadingImage = $('.loading-overlay');
            $ctrl.timer = null;
            $ctrl.includeAllResults = true;

            var metaSite = $("meta[name=siteName]").attr("content");

            if (metaSite) {
                $ctrl.selectedSites.push(metaSite);
            }


            var searchParams = $location.search();

            $ctrl.filterWindow = $('.filter-modal');
            $ctrl.modal = $('.wrap-modal');

            $ctrl.init = function(pageSize, externalPageSize, maxPages, includeAllResults) {
                if ($ctrl.text !== "") {
                    $ctrl.search(null, pageSize, externalPageSize, maxPages);
                }

                if ($ctrl.selectedSites.length > 0 && includeAllResults != null) {
                    $ctrl.includeAllResults = (includeAllResults.toLowerCase() == "true");
                }
            }

            $ctrl.search = function (e, pageSize, externalPageSize, maxPages) {
                if (e) {
					e.preventDefault();

                    if ($ctrl.text !== "") {
                        var oldQueryIndex = $window.location.href.indexOf('?queryString=');
                        var url = $window.location.href;

                        if (oldQueryIndex !== -1) {
                            url = url.slice(0, oldQueryIndex);
                        }

                        $window.location.href = url + "?queryString=" + encodeURIComponent($ctrl.text);
                    }

                    $ctrl.selectedCategories = [];
                    $ctrl.selectedContentTypes = [];
                    $ctrl.selectedPublications = [];
                }

                $('#searchResults').hide();

                $ctrl.loadingImage.show();

                //setLoadingSpinner();

                $(".ui-menu-item").hide();

                $ctrl.page = 1;
				$ctrl.results = [];
                $ctrl.externalResults = [];
                $ctrl.pageSize = pageSize;
                $ctrl.maxPages = maxPages;
                $ctrl.externalPageSize = externalPageSize;

                if ($ctrl.includeAllResults) {
                    $ctrl.selectedSites = [];
                }

                pageSearchService.getResults($ctrl.text, $ctrl.selectedSites, $ctrl.selectedCategories, $ctrl.selectedContentTypes, $ctrl.selectedPublications)
                    .then(function(results) {
                        results.Results.forEach(function(result) {
                            $ctrl.results.push(result);
                        });

                        $ctrl.shownResults = $ctrl.results.slice(0, pageSize);

                        $ctrl.sites.forEach(function(filter) {
                            filter.Count = 0;
                        });
                        $ctrl.contentTypes.forEach(function (filter) {
                            filter.Count = 0;
                        });
                        $ctrl.publications.forEach(function (filter) {
                            filter.Count = 0;
                        });

                        results.SiteFilters.forEach(function(filter) {
                            var index = $ctrl.sites.findIndex(function(e) {
                                return e.Name === filter.Name;
                            });

                            $ctrl.sites.splice(index, 1, filter);
                        });

						$ctrl.sitesHits = $ctrl.sum($ctrl.sites, 'Count');

						//only push filters if this is a new search term
						if (!$ctrl.categoryFilters.length) {

							results.TagFilters.Containers.forEach(function(container) {
								$ctrl.categoryFilters.push(container);
							});
						}
						else // update existing counts
                        {
                            $ctrl.categoryFilters = results.TagFilters.Containers;
						}

						results.ContentTypeFilters.forEach(function (filter) {
                            var index = $ctrl.contentTypes.findIndex(function (e) {
                                return e.Name === filter.Name;
                            });

						    if (index !== -1) {
						        $ctrl.contentTypes.splice(index, 1, filter);
						    } else {
						        $ctrl.contentTypes.push(filter);
						    }
						});

                        $ctrl.contentTypeHits = $ctrl.sum($ctrl.contentTypes, 'Count');

                        results.PublicationFilters.forEach(function(filter) {
                            var index = $ctrl.publications.findIndex(function(e) {
                                return e.Name === filter.Name;
                            });

                            $ctrl.publications.splice(index, 1, filter);
                        });

                        $ctrl.publicationHits = $ctrl.sum($ctrl.publications, 'Count');

                        $ctrl.totalResults = results.Results.length;

                        var pageCount = 1;

                        if ($ctrl.totalResults > pageSize) {
                            pageCount = Math.ceil($ctrl.totalResults / pageSize);
                        }
                        var pages = [];

                        for (var index = 1; index <= pageCount; index++) {
                            pages.push(index);
                        }

                        $ctrl.pages = pages;
                        
                        $ctrl.loadingImage.hide();
                        $('#searchResults').show();
                    },
                    function() {
                        console.log('an error occured getting results');
                    });

                pageSearchService.getExternalResults($ctrl.text)
                    .then(function(results) {
                        results.Results.forEach(function(result) {
                            $ctrl.externalResults.push(result);

                            $ctrl.shownExternalResults = $ctrl.externalResults.slice(0, externalPageSize);
                        });
                    },
                    function() {
                        console.log('an error occured getting external results');
                    });
            }

            if (searchParams.queryString) {
                $ctrl.text = searchParams.queryString.replace(/&#39;/g, "\'").replace(/&quot;/g, "\"").replace(/&amp;/g, "&");
            }

            if (searchParams.publication) {
                $ctrl.selectedPublications.push(searchParams.publication);
            }

            $ctrl.clearText = function() {
                $ctrl.text = "";
            }

            $ctrl.sortByRelevance = function () {
                var skip = ($ctrl.page - 1) * $ctrl.pageSize;

                if ($ctrl.sort === "relevance") {
                    if ($ctrl.relOrder === "asc") {
                        $ctrl.relOrder = "desc";
                    } else if ($ctrl.relOrder === "desc") {
                        $ctrl.relOrder = "asc";
                    }
                } else {
                    $ctrl.sort = "relevance";
                }

                if ($ctrl.relOrder === "desc") {
                    $ctrl.results.sort(byRelevanceDesc);
                } else if ($ctrl.relOrder === "asc") {
                    $ctrl.results.sort(byRelevanceAsc);
                }

                $ctrl.shownResults = $ctrl.results.slice(skip, skip + $ctrl.pageSize);
            }

            $ctrl.sortByDate = function () {
                var skip = ($ctrl.page - 1) * $ctrl.pageSize;

                if ($ctrl.sort === "date") {
                    if ($ctrl.dateOrder === "asc") {
                        $ctrl.dateOrder = "desc";
                    } else if ($ctrl.dateOrder === "desc") {
                        $ctrl.dateOrder = "asc";
                    }
                } else {
                    $ctrl.sort = "date";
                }

                if ($ctrl.dateOrder === "desc") {
                    $ctrl.results.sort(byDateDesc);
                } else if ($ctrl.dateOrder === "asc") {
                    $ctrl.results.sort(byDateAsc);
                }

                $ctrl.shownResults = $ctrl.results.slice(skip, skip + $ctrl.pageSize);
			}

			$ctrl.trackClick = function(ev, href) {
				ev.preventDefault();
				var redirectBase = href.split("?")[0];
				var queryStr = queryString(href);

                var t_id = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_id'; }), 1);
                var t_q = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_q'; }), 1);
                var t_hit_id = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_hit.id'; }), 1);
                var t_hit_pos = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_hit.pos'; }), 1);
                var t_ip = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_ip'; }), 1); // not used, but needs to be removed
                var t_tags = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_tags'; }), 1); // not used, but needs to be removed

				//create redirect url
				if (queryStr.length > 0) {
					redirectBase = redirectBase + "?";
					var params = [];
					queryStr.forEach(function(item) {
						var queryParam = item.id + "=" + item.value;
						params.push(queryParam);
					});
					redirectBase = redirectBase + params.join('&');
				}

				//track click
				if (t_id[0].value && t_q[0].value && t_hit_id[0].value && t_hit_pos[0].value ) {
					pageSearchService.trackClick(t_id[0].value, t_q[0].value, t_hit_id[0].value, t_hit_pos[0].value)
						.then(function (response) {
								console.log(response);
							},
							function () {
								console.log('an error occured registering click event');
							});
				}

				$window.location.href = redirectBase;
			}

            $ctrl.toggleFilter = function (id, collection, pageSize, externalPageSize, maxPages) {
                var index = collection.indexOf(id);

                if (index > -1) {
                    collection.splice(index, 1);
                } else {
                    collection.push(id);
                }

                $ctrl.search(null, pageSize, externalPageSize, maxPages);
            }

            $ctrl.toggleContentTypes = function (type, pageSize, externalPageSize, maxPages) {
                var index = $ctrl.selectedContentTypes.indexOf(type);

                if (index > -1) {
                    $ctrl.selectedContentTypes.splice(index, 1);
                } else {
                    $ctrl.selectedContentTypes.push(type);
                }

                $ctrl.search(null, pageSize, externalPageSize, maxPages);
            }

            $ctrl.togglePublications = function (publication, pageSize, externalPageSize, maxPages) {
                var index = $ctrl.selectedPublications.indexOf(publication);

                if (index > -1) {
                    $ctrl.selectedPublications.splice(index, 1);
                } else {
                    $ctrl.selectedPublications.push(publication);
                }

                $ctrl.search(null, pageSize, externalPageSize, maxPages);
            }

            $ctrl.expandModal = function() {
                $ctrl.filterWindow.addClass('open-filter');
                $ctrl.modal.removeClass('filter-hide').addClass('filter-show');
            }

            $ctrl.closeModal = function() {
                $ctrl.filterWindow.removeClass('open-filter');
                $ctrl.modal.addClass('filter-hide').removeClass('filter-show');
            }

            $ctrl.showAllExternal = function(externalSearchUrl) {
                $window.location.href = "/" + externalSearchUrl + "?queryString=" + encodeURIComponent($ctrl.text);
			}

			$ctrl.queryString = function(url) {
				
			}

	        /**
	         * This function returns an array that contains every get parameter from a URL (first argument) as a property
	         * 
	         * @param URL {String}
	         */
	        function queryString(url) {
		        // This function is anonymous, is executed immediately and 
		        // the return value is assigned to QueryString!
		        var query_string = [];
		        var usefulParam = url.split("?")[1] || "";
		        var query = usefulParam || "";
				var vars = query.split("&");

		        for (var i = 0; i < vars.length; i++) {
			        var pair = vars[i].split("=");
			        query_string.push({ id: pair[0], value: pair[1] });
		        }

		        return query_string;
	        }


            function byDateDesc(a, b) {
                if (a.Date > b.Date) {
                    return -1;
                }
                if (a.Date < b.Date) {
                    return 1;
                }
                return 0;
            }

            function byDateAsc(a, b) {
                if (a.Date < b.Date) {
                    return -1;
                }
                if (a.Date > b.Date) {
                    return 1;
                }
                return 0;
            }

            $ctrl.sum = function(collection, prop) {
                return collection.reduce(function(a, b) {
                    return a + b[prop];
                }, 0);
            }

            function byRelevanceDesc(a, b) {
                if (a.Relevance < b.Relevance) {
                    return 1;
                }
                if (a.Relevance > b.Relevance) {
                    return -1;
                }

                return 0;
            }

            function byRelevanceAsc(a, b) {
                if (a.Relevance > b.Relevance) {
                    return 1;
                }
                if (a.Relevance < b.Relevance) {
                    return -1;
                }

                return 0;
            }


			function recursiveCountReset(collection) {
				collection.Count = 0;
                collection.Categories.forEach(function (e) {
                    recursiveCountReset(e);
                });

                return true;
            }

            //function setLoadingSpinner() {
            //    $ctrl.timer && clearTimeout($ctrl.timer);

            //    $ctrl.timer = setTimeout(function() {
            //        $ctrl.loadingImage.show();
            //    }, 1000);
            //}
        }
    }

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_pageSearch.js
// module id = 14
// module chunks = 0